import { translate, LANGUAGE, languageTag, languagePath } from "../i18n";
import { PRODUCTS } from './products';
import { SEO_PAGES } from './seoPages';
import { SEO_SERVICES } from './seoServices';
export const SITE_ORIGIN = 'https://www.pedrazziniprint365.ch';
export const HOME_SEO = {
  path: '/',
  name: 'Pedrazzini Print 365',
  title: translate("Tipografia Locarno | Pedrazzini Print 365"),
  description: translate("Tipografia a Locarno per stampa digitale, stampati aziendali, brochure, etichette e grande formato. Preventivo personalizzato entro 24 ore.")
};
export const SEO_ROUTES = [HOME_SEO, {
  path: "/proposte/natale-2026/",
  name: translate("Proposte di Natale 2026"),
  title: translate("Regali e stampa personalizzata Natale 2026 | Pedrazzini"),
  description: translate("Idee di Natale per aziende e privati a Locarno: calendari, biglietti di auguri, regali ed etichette personalizzati. Scopri le proposte Pedrazzini Print 365."),
  seasonal: true
}, ...SEO_PAGES.map(p => ({
  path: `/prodotti/${p.slug}/`,
  name: p.title,
  title: `${p.title} | Pedrazzini Print 365`,
  description: p.description
})), ...SEO_SERVICES.map(p => ({
  path: `/servizi/${p.slug}/`,
  name: p.nav,
  title: translate("{0} a Locarno | Pedrazzini Print 365", {
    0: p.nav
  }),
  description: p.description
})), ...PRODUCTS.map(p => ({
  path: `/catalogo/${p.id}/`,
  name: p.title,
  title: translate("{0} a Locarno | Pedrazzini Print 365", {
    0: p.title
  }),
  description: translate("{0} a Locarno. {1} Preventivo su misura.", {
    0: p.title,
    1: p.description
  })
}))].map(page => ({ ...page, basePath: page.path, path: languagePath(page.path), language: LANGUAGE }));
export function pageSeo(pathname) {
  const basePath = pathname.replace(/^\/(de|fr)(?=\/|$)/, '') || '/';
  const path = languagePath(basePath === '/' ? '/' : `${basePath.replace(/\/+$/, '')}/`);
  return SEO_ROUTES.find(p => p.path === path) || {
    path, basePath, language: LANGUAGE,
    name: translate("Pagina non trovata"),
    title: translate("Pagina non trovata | Pedrazzini Print 365"),
    description: translate("La pagina richiesta non esiste. Scopri i prodotti e i servizi di Pedrazzini Print 365 a Locarno."),
    noindex: true
  };
}
export function pageSchema(page) {
  if (page.noindex || page.basePath === '/') return [];
  return [{
    '@context': 'https://schema.org',
    '@type': page.seasonal ? 'CollectionPage' : 'Service',
    ...(page.seasonal ? {
      datePublished: '2026-09-15',
      inLanguage: languageTag
    } : {}),
    name: page.name,
    description: page.description,
    url: SITE_ORIGIN + page.path,
    ...(page.seasonal ? {
      publisher: {
        '@id': SITE_ORIGIN + '/#azienda'
      }
    } : {
      provider: {
        '@id': SITE_ORIGIN + '/#azienda'
      },
      areaServed: {
        '@type': 'AdministrativeArea',
        name: translate("Canton Ticino")
      }
    })
  }, {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [{
      '@type': 'ListItem',
      position: 1,
      name: translate("Home"),
      item: SITE_ORIGIN + languagePath('/')
    }, {
      '@type': 'ListItem',
      position: 2,
      name: page.name,
      item: SITE_ORIGIN + page.path
    }]
  }];
}

export function languageAlternates(page) {
  if (page.noindex) return [];
  return [...["it", "de", "fr"].map(lang => ({lang: lang + "-CH", href: SITE_ORIGIN + languagePath(page.basePath, lang)})), {lang:"x-default",href:SITE_ORIGIN + page.basePath}];
}
